"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var Modal_1 = require("./Modal");

var ClickOutside =
/** @class */
function (_super) {
  __extends(ClickOutside, _super);

  function ClickOutside() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.closeModal = function () {
      _this.props.modalClose();
    };

    return _this;
  }

  ClickOutside.prototype.render = function () {
    return react_1.default.createElement(Modal_1.OutsideWrapper, null, react_1.default.createElement(Modal_1.LefBox, {
      onPress: this.closeModal
    }), this.props.children, react_1.default.createElement(Modal_1.RightBox, {
      onPress: this.closeModal
    }), react_1.default.createElement(Modal_1.BottomBox, {
      onPress: this.closeModal
    }));
  };

  return ClickOutside;
}(react_1.default.Component);

exports.ClickOutside = ClickOutside;